import { useNotification } from '../../../hooks'
import { getValuesFromOptions } from '../../../utils/filter'
import { parseServerValidation } from '../../../utils/validation'
import { FormModal } from '../../Form'
import { createFilterTemplate } from '../Filter.api'
import { FilterSaveModalFields } from '../FilterSaveModalFields'

import { FILTER_SAVE_MODAL_INITIAL_VALUES } from './FilterSaveModal.constants'
import {
  createNewFilterGetValidationSchema,
  getPayload,
} from './FilterSaveModal.utils'

function FilterSaveModal(props) {
  const { entity, filterOptions } = props

  const { handleAddSuccessNotification } = useNotification()

  function handleSubmit({ setErrors, setSubmitting, value }) {
    const params = getValuesFromOptions(filterOptions)

    createFilterTemplate({
      ...value,
      filter_values: params,
      table_name: entity.plural,
    })
      .then(() => {
        props.onClose?.()

        handleAddSuccessNotification('Notification.CommonTitleSavedKey')
      })
      .catch(({ response }) => {
        setSubmitting(false)
        setErrors(parseServerValidation(response.data))
      })
  }

  const validationSchema = createNewFilterGetValidationSchema()

  return (
    <FormModal
      Fields={FilterSaveModalFields}
      containerProps={{
        confirmationApplyText: 'Modal.CommonDiscardBtnKey',
        confirmationCancelText: 'Modal.CommonGoBackBtnKey',
        confirmationDescription:
          'Modal.CancelSaveAsTemplateConfirmationTitleKey',
      }}
      formBodyProps={{ withNotifications: true }}
      formTitle='Modal.SaveAsTemplateTitleKey'
      getPayload={getPayload}
      initialValues={FILTER_SAVE_MODAL_INITIAL_VALUES}
      validationSchema={validationSchema}
      onClose={props.onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default FilterSaveModal
